import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import UserProfilesPartnershipForm from '../containers/UserProfilesPartnershipFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class UserProfilesPartnershipEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `UserProfilesPartnershipEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('user_profiles_partnership_route_edit')} />
          <UserProfilesPartnershipForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default UserProfilesPartnershipEditScreen;

Logger.log('silly', `PartnershipEditScreen loaded.`);
